import { isGiftProductItem, isSubscriptionItem, PdProductItem } from 'interfaces/line-item';
import { CartItemInput, TargetCartItem } from 'contexts/type/cart-type';

interface ToCartItemParams {
  item: PdProductItem;
  shouldQuantity?: boolean;
}

/**
 * Converts PdProductItem to CartItemInput or TargetCartItem.
 * If shouldQuantity it replaces quantity with new value.
 */
export function toCartItem(params: { item: PdProductItem; shouldQuantity?: true }): CartItemInput;
export function toCartItem(params: { item: PdProductItem; shouldQuantity: false }): TargetCartItem;
export function toCartItem({
  item,
  shouldQuantity = true,
}: ToCartItemParams): CartItemInput | TargetCartItem {
  const base = {
    variantId: String(item.variantId),
    ...(item.bundleRefs?.length ? { bundleRefs: item.bundleRefs } : {}),
    ...(item.petType ? { petType: item.petType } : {}),
  };
  const quantity = shouldQuantity ? { quantity: item.quantity } : {};
  let extras = {};

  if (isGiftProductItem(item)) {
    extras = { redeemItem: true, points: item.points };
  } else if (isSubscriptionItem(item)) {
    extras = { interval: item.interval };
  }

  return { ...base, ...quantity, ...extras };
}
